// @ts-nocheck
import { IconCheck, IconEye } from '@tabler/icons-react';
import { Card, Code, SimpleGrid, Stack, Text, Title } from '@/components/ui';
import {
  AiInsightCard,
  AiInsightFeed,
} from '../../../../components/advanced/Widgets';
import {
  mockAiInsights,
  mockTrendInsights,
  mockRecommendationInsights,
  mockHighConfidenceInsights,
} from '../../mockData/widgets';

export default function AiInsightWidgetsPage() {
  return (
    <Stack gap="xl">
      <Stack gap="xs">
        <Title order={2}>AI Insight Widgets</Title>
        <Text c="dimmed" size="sm">
          Display AI-generated insights and recommendations with confidence scores and
          action buttons. Perfect for ML/AI platforms and data analytics applications.
        </Text>
      </Stack>

      {/* AI Insight Card */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>AiInsightCard</Title>
          <Text size="sm" c="dimmed">
            Beautiful gradient cards for AI-generated insights with confidence indicators.
          </Text>

          <Stack gap="md">
            {mockAiInsights.slice(0, 3).map((insight) => (
              <AiInsightCard
                key={insight.id}
                insight={{
                  ...insight,
                  actions: [
                    {
                      label: 'View Details',
                      onClick: () => console.log('View details'),
                      variant: 'primary',
                      icon: <IconEye size={16} />,
                    },
                    {
                      label: 'Dismiss',
                      onClick: () => console.log('Dismiss'),
                      variant: 'secondary',
                    },
                  ],
                }}
                showConfidence
                showTimestamp
                showCategory
              />
            ))}
          </Stack>

          <Code block>
{`<AiInsightCard
  insight={{
    id: '1',
    title: 'Revenue Growth Acceleration',
    content: 'MRR is growing **15% faster**...',
    confidence: 0.87,
    category: 'trend',
    timestamp: new Date()
  }}
  showConfidence
/>`}
          </Code>
        </Stack>
      </Card>

      {/* AI Insight Feed */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>AiInsightFeed</Title>
          <Text size="sm" c="dimmed">
            Feed of multiple insights with category filtering and confidence thresholds.
          </Text>

          <SimpleGrid cols={{ base: 1, lg: 2 }} spacing="md">
            <AiInsightFeed
              insights={mockTrendInsights}
              maxItems={3}
              filterByCategory={['trend']}
              onViewAll={() => console.log('View all trends')}
              onDismiss={(id) => console.log('Dismissed:', id)}
            />

            <AiInsightFeed
              insights={mockHighConfidenceInsights}
              maxItems={3}
              filterByConfidence={0.8}
              onViewAll={() => console.log('View all high confidence')}
              onDismiss={(id) => console.log('Dismissed:', id)}
              variant="compact"
            />
          </SimpleGrid>

          <Code block>
{`<AiInsightFeed
  insights={allInsights}
  maxItems={5}
  filterByCategory={['trend', 'recommendation']}
  filterByConfidence={0.7}
  onViewAll={handleViewAll}
/>`}
          </Code>
        </Stack>
      </Card>

      {/* Recommendation Examples */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>Recommendation Insights</Title>
          <Text size="sm" c="dimmed">
            Actionable recommendations with detailed steps.
          </Text>

          <Stack gap="md">
            {mockRecommendationInsights.slice(0, 2).map((insight) => (
              <AiInsightCard
                key={insight.id}
                insight={{
                  ...insight,
                  actions: [
                    {
                      label: 'Apply Recommendation',
                      onClick: () => console.log('Apply'),
                      variant: 'primary',
                      icon: <IconCheck size={16} />,
                    },
                  ],
                }}
                variant="detailed"
                showConfidence
              />
            ))}
          </Stack>

          <Code block>
{`<AiInsightCard
  insight={{
    title: 'Optimize Database Queries',
    content: 'Analysis shows **12 slow queries**...',
    category: 'recommendation',
    confidence: 0.92,
    actions: [
      { label: 'Apply Fix', onClick: handleApply }
    ]
  }}
/>`}
          </Code>
        </Stack>
      </Card>

      {/* Use Cases */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>Common Use Cases</Title>
          <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">
            <Stack gap="xs">
              <Text size="sm" fw={500}>Data Analytics Platforms</Text>
              <Text size="xs" c="dimmed">
                Surface AI-discovered trends and anomalies in business data.
              </Text>
            </Stack>
            <Stack gap="xs">
              <Text size="sm" fw={500}>DevOps Automation</Text>
              <Text size="xs" c="dimmed">
                AI-powered recommendations for infrastructure optimization.
              </Text>
            </Stack>
            <Stack gap="xs">
              <Text size="sm" fw={500}>Forecasting Tools</Text>
              <Text size="xs" c="dimmed">
                Display ML-generated predictions with confidence levels.
              </Text>
            </Stack>
            <Stack gap="xs">
              <Text size="sm" fw={500}>Business Intelligence</Text>
              <Text size="xs" c="dimmed">
                Highlight key insights from large datasets automatically.
              </Text>
            </Stack>
          </SimpleGrid>
        </Stack>
      </Card>
    </Stack>
  );
}
